module.exports = __webpack_public_path__ + "static/media/SCOPE.jpg-s-mobile.55fdd73d.webp";